import React from 'react';


function ShopReceiptHeader(props) {
	
	return <>
		<div className="logo-container">
			{
				props.customerLogo != null && props.customerLogo.length > 0 && (
						<img className={"logo-base " + (props.aamsLogo? "" : "just-this")} src={props.customerLogo} />
				)
			}
			{
				props.aamsLogo && <>
					<img  className="logo-base aams-logo-img" src={props.aamsLogo} />
				</>
			}
		</div>
		<div className="operation-title">{props.operationTitle}</div>
	</>
}

export default ShopReceiptHeader;